module.exports = __webpack_public_path__ + "static/beats-artist-7a2d0572bd50ff25869d4de88405d587.jpg";